import React, {useState} from "react";
import apiClient from "../../clients/apiClient.js";
import { Box, Button, Flex, Grid, HStack, Input, InputGroup, InputLeftElement, Menu, MenuButton, MenuItem, MenuList, Spacer, Spinner, Text, VStack } from "@chakra-ui/react";
import { AddOutlined, MoreHoriz } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import ControlArrows from "../../utils/ControlArrows";
import SearchIcon from "@mui/icons-material/Search";


const UsersTab = ({teamMembers, setTeamMembers, loading, teamMembersData}) => {
    const [searchQuery, setSearchQuery] = React.useState(''); // State for search query
    const [sortColumn, setSortColumn] = useState('members');
    const [sortDirection, setSortDirection] = useState('asc');
    const [filteredMembers, setFilteredMembers] = useState(teamMembers);
  
    const [showPopup, setShowPopup] = useState(false);
    const [members, setMembers] = useState([
      {
        first_name: '',
        last_name: '',
        email: '',
        role: 'default',
      },
    ]);
  
  
    React.useEffect(() => {
      setFilteredMembers(teamMembers?.filter(
        (user) =>
          user.first_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          user.last_name?.toLowerCase().includes(searchQuery.toLowerCase())
      ));
    }, [searchQuery, teamMembers])
  
    React.useEffect(() => {
      if (sortDirection === "asc") {
          const sortedMembers = [...(filteredMembers || [])].sort((a, b) => {
              if (sortColumn === "members") {
                  return (a.first_name+a.last_name).localeCompare(b.first_name+b.last_name);
              } else if (sortColumn === "role") {
                  return a.role.localeCompare(b.role);
              }
              return 0;
          })
          setFilteredMembers(sortedMembers);
      } else {
          const sortedMembers = [...(filteredMembers || [])].sort((a, b) => {
              if (sortColumn === "members") {
                  return (b.first_name+b.last_name).localeCompare(a.first_name+a.last_name);
              } else if (sortColumn === "role") {
                  return b.role.localeCompare(a.role);
              }
              return 0;
          })
          setFilteredMembers(sortedMembers);
      }
  }, [sortColumn, sortDirection]);
  
    const handleAddMember = () => {
      setMembers([
        ...members,
        { first_name: '', last_name: '', email: '', role: 'default' },
      ]);
    };
  
    const handleInputChange = (index, field, value) => {
      const updatedMembers = [...members];
      updatedMembers[index][field] = value;
      setMembers(updatedMembers);
    };
  
    const handleClose = () => {
      setShowPopup(false);
    };
  
    const handleInvite = async () => {
      // Send invite logic
      console.log('Inviting members:', members);
      const inviteMembers = [];
      members.map((member, index) =>
        inviteMembers.push({
          first_name: member.first_name,
          last_name: member.last_name,
          email: member.email,
          role: member.role,
        })
      );
      apiClient.post('/account-settings/team-management', {
        action: 'invite_members',
        invite_members: inviteMembers,
      }).then(({data}) => {
        console.log("Data:", data);
        if (data.error) {
        alert(data.error);
        return;
        }
        setTeamMembers(data.employees_info);
        window.location.reload();
      }).catch((error) => {
        return;
      });
      // const response = await fetch('/account-settings/team-management', {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   credentials: 'include',
      //   body: JSON.stringify({
      //     action: 'invite_members',
      //     invite_members: inviteMembers,
      //   }), // Send updated data as JSON
      // });
  
      // if (!response.ok) {
      //   throw new Error('Failed to save data');
      // } else {
      // }
  
      setShowPopup(false);
    };
  
    if (loading || !teamMembers)
      return (
        <Flex width={'100%'} height="72vh" justifyContent={'center'} alignItems={"center"} py={20}>
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="blue.500"
            size="lg"
          />
        </Flex>
      );
  
  
    const handleRemoveAccess = (email) => {
      // Send invite logic
      console.log('Revoking Email:', email);
      const revokeMember = {
        email: email,
      };
      apiClient.post('/account-settings/team-management', {
        action: 'revoke_access',
        revoke_access: revokeMember,
      }).then(({data}) => {
        setTeamMembers(data.employees_info);
        window.location.reload();
      })
    };
  
    const isInviteDisabled = () => {
      if (teamMembersData?.max_members_allowed == teamMembers?.length) {
        return true;
      }
  
      if (teamMembersData?.can_invite_team_members == false) {
        return true;
      }
  
      return false;
    }
  
    const isRemoveAccessDisabled = () => {
      if (teamMembersData?.can_revoke_team_members == false) {
        return true;
      }
  
      return false;
    }
  
    return (
      <Box marginBottom={"24px"}>
        <Flex align="center" mb={4} gap={"24px"}>
          <InputGroup maxW="240px" borderRadius={"8px"}>
            <InputLeftElement pointerEvents="none">
              {/* <IconButton icon={SearchIcon} style={{ color: 'grey' }} /> */}
              <IconButton style={{ color: 'grey' }} ><SearchIcon/></IconButton>
            </InputLeftElement>
            <Input
              placeholder="Search"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)} // Update search query
            />
          </InputGroup>
  
  
          <Menu placement="bottom" justify={"flex-end"} offset={[0, 0]}>
            <MenuButton 
              as={Button} 
              bg="transparent" 
              border={"1px"}
              borderColor={"#E5E5E5"} 
              borderRadius={"40px"} 
              height={"32px"} 
              width={"76px"}
              justifyContent={"center"} 
              alignContent={"center"}
              _active={{ bg: "transparent" }}
              _focus={{ bg: "transparent" }}
              _hover={{
                // backgroundColor: 'blue.500',  // Change background on hover
                // color: '#2584fd',  // Change text color on hover
                // borderColor: "#adadad",
                border: "1px solid #adadad",
              }}
            >
              <HStack height="16px" alignItems="center" gap="2px">
  
                <IconButton
                  sx={{ padding: 0, fontSize: "16px", color: "#5D5D5D", height: "16px", width: "16px", border: "1px" }}
                >
                  <AddOutlined sx={{ padding: 0, fontSize: "14px" }}/>
                </IconButton>
                <Text
                  marginLeft={"2px"}
                  color="#1d1d1d" 
                  fontSize="12px" 
                  lineHeight="16px"
                  fontWeight={"400"} 
                  alignSelf="flex-start"
                  fontFamily={"'Inter', sans-serif"}
                >
                  Role
                </Text>
              </HStack>
            </MenuButton>
            {/* <MenuList minW="unset" width={"162px"}>
              <MenuItem color={"#1d1d1d"} fontFamily={"sans-serif"} fontWeight={"400"} fontSize={"13px"} onClick={() => setFilterType('All questions')}>
                All questions
              </MenuItem>
              {getUnfilledAnswers() > 0 && (
                <MenuItem color={"#1d1d1d"} fontFamily={"sans-serif"} fontWeight={"400"} fontSize={"13px"} onClick={() => setFilterType('Unfilled')}>
                  Unfilled
                </MenuItem>
              )}
              {getUnreviewedAnswers() > 0 && (
                <MenuItem color={"#1d1d1d"} fontFamily={"sans-serif"} fontWeight={"400"} fontSize={"13px"} onClick={() => setFilterType('Unreviewed')}>
                    Unreviewed
                </MenuItem>
              )}
              {getCompletedAnswers() > 0 && (
                <MenuItem color={"#1d1d1d"} fontFamily={"sans-serif"} fontWeight={"400"} fontSize={"13px"} onClick={() => setFilterType('Completed')}>
                    Completed
                </MenuItem>
              )}
            </MenuList> */}
          </Menu>
  
          <Menu placement="bottom" justify={"flex-end"} offset={[0, 0]}>
            <MenuButton 
              as={Button} 
              bg="transparent" 
              border={"1px"}
              borderColor={"#E5E5E5"} 
              borderRadius={"40px"} 
              height={"32px"} 
              width={"86px"}
              justifyContent={"center"} 
              alignContent={"center"}
              _active={{ bg: "transparent" }}
              _focus={{ bg: "transparent" }}
              _hover={{
                // backgroundColor: 'blue.500',  // Change background on hover
                // color: '#2584fd',  // Change text color on hover
                // borderColor: "#adadad",
                border: "1px solid #adadad",
              }}
            >
              <HStack height="16px" alignItems="center" gap="2px">
  
                <IconButton
                  sx={{ padding: 0, fontSize: "16px", color: "#5D5D5D", height: "16px", width: "16px", border: "1px" }}
                >
                  <AddOutlined sx={{ padding: 0, fontSize: "14px" }}/>
                </IconButton>
                <Text
                  marginLeft={"2px"}
                  color="#1d1d1d" 
                  fontSize="12px" 
                  lineHeight="16px"
                  fontWeight={"400"} 
                  alignSelf="flex-start"
                  fontFamily={"'Inter', sans-serif"}
                >
                  Status
                </Text>
              </HStack>
            </MenuButton>
            {/* <MenuList minW="unset" width={"162px"}>
              <MenuItem color={"#1d1d1d"} fontFamily={"sans-serif"} fontWeight={"400"} fontSize={"13px"} onClick={() => setFilterType('All questions')}>
                All questions
              </MenuItem>
              {getUnfilledAnswers() > 0 && (
                <MenuItem color={"#1d1d1d"} fontFamily={"sans-serif"} fontWeight={"400"} fontSize={"13px"} onClick={() => setFilterType('Unfilled')}>
                  Unfilled
                </MenuItem>
              )}
              {getUnreviewedAnswers() > 0 && (
                <MenuItem color={"#1d1d1d"} fontFamily={"sans-serif"} fontWeight={"400"} fontSize={"13px"} onClick={() => setFilterType('Unreviewed')}>
                    Unreviewed
                </MenuItem>
              )}
              {getCompletedAnswers() > 0 && (
                <MenuItem color={"#1d1d1d"} fontFamily={"sans-serif"} fontWeight={"400"} fontSize={"13px"} onClick={() => setFilterType('Completed')}>
                    Completed
                </MenuItem>
              )}
            </MenuList> */}
          </Menu>
  
          <Spacer />
  
          <Text fontSize="16px" color="#fffff">
            {teamMembers?.length} / {teamMembersData?.max_members_allowed} Members
          </Text>
          <Button
            color={"white"}
            bgColor={"#2584FD"}
            colorScheme="blue"
            onClick={() => setShowPopup(true)}
            disabled={isInviteDisabled()}
            gap={"6px"}
            width={"158px"}
          >
            <IconButton
              sx={{ padding: 0, fontSize: "24px", color: "white", height: "24px", width: "24px" }}
            >
              <AddOutlined sx={{ padding: 0, fontSize: "22px" }}/>
            </IconButton>
            <Text fontSize={"16px"} lineHeight={"24px"} fontWeight={"600"}>
              Invite member
            </Text>
          </Button>
        </Flex>
        {/* Search and Actions */}
  
        {showPopup && (
          <div className="popup-overlay">
            <div className="popup-container">
              <div className="popup-header">
                <h2>Invite member</h2>
                <button className="close-button" onClick={handleClose}>
                  &times;
                </button>
              </div>
              <div className="popup-body">
                {members.map((member, index) => (
                  <div className="invite-row" key={index}>
                    <input
                      type="firstName"
                      placeholder="Joe"
                      value={member.first_name}
                      onChange={(e) =>
                        handleInputChange(index, 'first_name', e.target.value)
                      }
                      className="first-name-input"
                    />
                    <input
                      type="lastName"
                      placeholder="Smith"
                      value={member.last_name}
                      onChange={(e) =>
                        handleInputChange(index, 'last_name', e.target.value)
                      }
                      className="last-name-input"
                    />
                    <input
                      type="email"
                      placeholder="andy@example.com"
                      value={member.email}
                      onChange={(e) =>
                        handleInputChange(index, 'email', e.target.value)
                      }
                      className="email-input"
                    />
                    <select
                      value={member.role}
                      onChange={(e) =>
                        handleInputChange(index, 'role', e.target.value)
                      }
                      className="role-select"
                    >
                      <option value="default">Default</option>
                      <option value="admin">Admin</option>
                    </select>
                  </div>
                ))}
                <button className="add-member-button" onClick={handleAddMember}>
                  + Add member
                </button>
              </div>
              <div className="popup-footer">
                <button className="cancel-button" onClick={handleClose}>
                  Cancel
                </button>
                <button className="invite-button-footer" onClick={handleInvite}>
                  Invite
                </button>
              </div>
            </div>
          </div>
        )}
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
                <tr>
                    <th style={{ borderBottom: "1px solid #e5e5e5", padding: "8px", textAlign: "left" }}>
                        Members
                        <ControlArrows columnName="members" sortColumn={sortColumn} setSortColumn={setSortColumn} sortDirection={sortDirection} setSortDirection={setSortDirection}/>
                    </th>
                    <th style={{ borderBottom: "1px solid #e5e5e5", padding: "8px", textAlign: "left" }}>
                        Role
                        <ControlArrows columnName="role" sortColumn={sortColumn} setSortColumn={setSortColumn} sortDirection={sortDirection} setSortDirection={setSortDirection}/>
                    </th>
                    <th style={{ borderBottom: "1px solid #e5e5e5", padding: "8px", textAlign: "center" }}>
                        Actions
                    </th>
                </tr>
            </thead>
            <tbody style={{ height: "10px", overflowY: "hidden" }}>
                {filteredMembers.map((user) => {
                    const { department, email, first_name, last_name, role, status } = user;
                      return (
                        <tr key={user.email} style={{ width: "100%", textAlign: "left" }}>
                          <td style={{ borderBottom: "1px solid #e5e5e5", padding: "8px", textAlign: "left" }}>
                            <VStack align="start" gap={0}>
                              <Text fontWeight="500">
                                {first_name + ' ' + last_name}
                              </Text>
                              <Text fontSize="sm" color="gray.500">
                                {email}
                              </Text>
                            </VStack>
                          </td>
                          <td style={{ borderBottom: "1px solid #e5e5e5", padding: "8px", textAlign: "left" }}>{user.role ? user.role : ""}</td>
                          <td style={{ borderBottom: "1px solid #e5e5e5", padding: "8px", textAlign: "left" }}>
                          <Grid placeItems="center" h="100%">
                            <Menu placement="bottom" justify={"flex-end"} offset={[-0, -0]}>
                            <MenuButton
                              as={IconButton}
                              sx={{ paddingX: 0, paddingY: 0.5, "&:hover": { backgroundColor: "transparent" } }}
                            >
                              <MoreHoriz sx={{ padding: 0, fontSize: 20, color: "#A1B3D3", bgcolor: "transparent" }} />
                            </MenuButton>
                            <MenuList w={"fill"} overflow={"hidden"} minW={"unset"} placement="bottom-end">
                              <MenuItem w={"100%"} onClick={() => handleRemoveAccess(user.email)}>
                              <Button 
                                p={0}
                                m={0}
                                bg={"transparent"}
                                _hover={{ bg: "transparent" }}
                                disabled={isRemoveAccessDisabled()}
                              >
                                <Text
                                fontFamily={"sans-serif"} 
                                color={"red.700"} 
                                w={"100%"} 
                                fontSize={"14px"} 
                                p={0}
                                bg={"transparent"}
                                >
                                Remove Access
                                </Text>
                              </Button>
                              </MenuItem>
                            </MenuList>
                            </Menu>
                            </Grid>
                          </td>
                        </tr>
                      )})}
            </tbody>
        </table>
      </Box>
    )
  }

export default UsersTab;